// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixFieldSet } from '../Fields/FieldsImport';
export class HistoricalBrokerMessageGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.HISTORICAL_BROKER_MESSAGE_GROUP, null, pfixFieldSet);
    }
    getMessageID() {
        return this.GetValue(FieldsFactory.FIELD_ID);
    }
    getTimeStamp() {
        return this.GetValue(FieldsFactory.FIELD_DATE);
    }
    getProductID() {
        return this.GetValue(FieldsFactory.FIELD_PRODUCT_ID);
    }
    getSubject() {
        return this.GetValue(FieldsFactory.FIELD_TITLE);
    }
    getMessage() {
        return this.GetValue(FieldsFactory.FIELD_TEXT);
    }
    getIsUnread() {
        return this.GetValue(FieldsFactory.FIELD_IS_UNREAD);
    }
    getResponseCases() {
        return this.GetValue(FieldsFactory.FIELD_BROKER_MESSAGE_RESPONSE_CASES);
    }
    getDisplayMethod() {
        return this.GetValue(FieldsFactory.FIELD_DISPLAY_METHOD);
    }
    getCustomButtonsGroups() {
        return this.GetGroups(FieldsFactory.CUSTOM_BUTTONS_GROUP);
    }
}
